import { get, put } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface ModelInUse {
  feature: string;
  purpose: string;
  /** Cost category the customer sees it under */
  area: string;
  provider: "anthropic" | "openai";
  model: string;
  /** Set per environment (LLM_FEATURE_OVERRIDES) instead of the code default */
  overridden: boolean;
  /** Tried in order, e.g. ["bedrock:eu-central-1", "anthropic"] */
  platforms: string[];
  reasoningEffort: string | null;
  inputPerMillion: number | null;
  outputPerMillion: number | null;
}

/** Usage recorded outside the model factory (embeddings, legacy service names) */
export interface OtherModelService {
  service: string;
  purpose: string;
  area: string;
  client: string;
}

export interface ModelsInUse {
  features: ModelInUse[];
  otherServices: OtherModelService[];
}

/** Staff: what each AI feature uses in this environment. */
export const getModelsInUse = (): Promise<ApiResponse<ModelsInUse>> => get(`/models/in-use`, null);

export interface ClaudeRouteSettings {
  /** Tried in order, e.g. ["bedrock:eu-central-1", "anthropic"] */
  effective: string[];
  /** This deployment's LLM_CLAUDE_ROUTE */
  environment: string[];
  /** Set by staff; null when the environment's route applies */
  override: string[] | null;
  updatedBy: string | null;
  updatedAt: string | null;
  available: string[];
}

/** Staff: where Claude runs, in order. */
export const getClaudeRoute = (): Promise<ApiResponse<ClaudeRouteSettings>> => get(`/models/claude-route`, null);

/** Staff: change where Claude runs (null: back to the environment's route). Applies within 30 s. */
export const setClaudeRoute = (route: string[] | null): Promise<ApiResponse<ClaudeRouteSettings>> =>
  put(`/models/claude-route`, { route });
